module.exports = __webpack_public_path__ + "img/27.d7b73066.jpg";